<app-dialog
  [(visible)]="visible"
  [closable]="true"
  [headerTitle]="headerTitle()"
  width="60vw"
>
  <div class="flex flex-col gap-2">
    <app-dados-localizacao-demanda
      [showMapa]="true"
      [showTipoObra]="true"
      [showData]="mode() === 'visualizar'"
      [tipoObraId]="tipoObraId()"
      [dadosLocalizacao]="dadosLocalizacaoDemanda()"
    />

    @if (exibirFormularioRepresentacaoGovbr()) {
      <app-form-representacao-govbr mode="reforcar"/>
    }

    @if (form) {
      <app-form-descricao-demanda [form]="form" [editMode]="mode() === 'reforcar'"
                                  [hideTipoRepresentacaoFormField]="exibirFormularioRepresentacaoGovbr()"/>
    }

    @if (mode() === 'reforcar') {
      <app-form-anexos-demanda
        [editMode]="true"
        (anexosChange)="onAnexosChange($event)"
        (uploadStatusChange)="onUploadStatusChange($event)"
      />
    } @else if (demanda()?.arquivos?.length) {
      <app-form-anexos-demanda [editMode]="mode() === 'reforcar'" [viewAnexos]="demanda()!.arquivos"/>
    }
  </div>

  <div class="flex justify-end gap-2" footer>
    <p-button [label]="mode() === 'visualizar' ? 'Fechar' : 'Cancelar'" styleClass="btn-outlined"
              [disabled]="uploadEmAndamento() || submitting"
              (onClick)="onCancelar()"
              (keydown.enter)="$event.preventDefault(); onCancelar()"
              (keydown.space)="$event.preventDefault(); onCancelar()">
      <app-icon-bold-close-square size="21px"/>
    </p-button>
    @if (mode() === 'reforcar') {
      <p-button
        label="Reforçar Demanda"
        styleClass="btn-red"
        [disabled]="uploadEmAndamento() || submitting"
        [loading]="submitting"
        (onClick)="onReforcar()"
        (keydown.enter)="$event.preventDefault(); onReforcar()"
        (keydown.space)="$event.preventDefault(); onReforcar()"
      >
        @if (!submitting) {
          <app-icon-location-add color="currentColor"/>
        }
      </p-button>
    }
  </div>
</app-dialog>

@if (showConfirmReforcarDialog()) {
  <app-dialog
    [(visible)]="showConfirmReforcarDialog"
    [closable]="false"
    [headerTitle]="'Confirmar Reforço da Demanda'"
    width="auto"
  >
    <div class="flex flex-col gap-6">
      <span>Deseja realmente reforçar esta demanda?</span>
    </div>

    <div class="flex justify-end gap-2" footer>
      <p-button label="Cancelar" styleClass="btn-outlined"
                (onClick)="showConfirmReforcarDialog.set(false)"
                (keydown.enter)="$event.preventDefault(); showConfirmReforcarDialog.set(false)"
                (keydown.space)="$event.preventDefault(); showConfirmReforcarDialog.set(false)">
        <app-icon-bold-close-square size="21px"/>
      </p-button>
      @if (mode() === 'reforcar') {
        <p-button
          label="Sim, reforçar"
          styleClass="btn-red"
          [loading]="submitting"
          (onClick)="onSubmit()"
          (keydown.enter)="$event.preventDefault(); onSubmit()"
          (keydown.space)="$event.preventDefault(); onSubmit()"
        >
          <app-icon-location-add [hidden]="submitting" color="currentColor"/>
        </p-button>
      }
    </div>
  </app-dialog>
}
